const API_BASE_URL = 'https://trajetus.net';

// Função para obter o token do localStorage
const getAuthToken = () => {
  return localStorage.getItem('token');
};

// Função para criar headers com autenticação
const getAuthHeaders = () => {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

// Função para garantir URL correta
const buildApiUrl = (endpoint) => {
  const baseUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL : `${API_BASE_URL}/`;
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${baseUrl}${cleanEndpoint}`;
};

class TipoDespesaService {
  async listar() {
    const response = await fetch(buildApiUrl('api/tipos-despesa'), {
      headers: getAuthHeaders()
    });
    const data = await response.json();
    if (!response.ok) {
      const message = data?.message || data?.error || `Erro ao listar tipos de despesa (${response.status})`;
      throw new Error(message);
    }
    return data;
  }

  async listarPorUsuario(id_usuario) {
    const response = await fetch(buildApiUrl(`api/tipos-despesa/usuario/${id_usuario}`), {
      headers: getAuthHeaders()
    });
    const data = await response.json();
    if (!response.ok) {
      const message = data?.message || data?.error || `Erro ao listar tipos de despesa (${response.status})`;
      throw new Error(message);
    }
    return data;
  }

  async criar(dados) {
    const response = await fetch(buildApiUrl('api/tipos-despesa'), {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(dados)
    });
    return await response.json();
  }

  async atualizar(id, dados) {
    const response = await fetch(buildApiUrl(`api/tipos-despesa/${id}`), {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(dados)
    });
    return await response.json();
  }

  async excluir(id) {
    const response = await fetch(buildApiUrl(`api/tipos-despesa/${id}`), {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });
    return await response.json();
  }
}

export default new TipoDespesaService();
